import * as Dialog from "@radix-ui/react-dialog";
import { Button } from "../../Button";
import { ArrowLeft } from "@/icons";
import "./BaseModalBackHeader.scss";

type BaseModalBackProps = {
  onBackClick: () => void;
  backButton: string;
  children?: React.ReactNode;
};

export const BaseModalBackHeader = ({
  onBackClick,
  backButton,
  children,
}: BaseModalBackProps) => {
  return (
    <header className="ui-base-modal-back-header">
      <Button
        size="4"
        textColor="primary"
        bg="transparent"
        aria-label="Torna indietro"
        onClick={onBackClick}
        className="ui-base-modal-back-button"
      >
        <ArrowLeft className="mr-x8" />
        {backButton}
      </Button>
      <Dialog.Title className="ui-base-modal-back-header-title fs-3 text-slate-20 fw-bold">
        {children}
      </Dialog.Title>
    </header>
  );
};
